// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/MARBLE-01-Black.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
  font-family: inherit;
  color: inherit;
  box-sizing: inherit;
}
*::before, *::after {
  box-sizing: inherit;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

li {
  list-style: none;
}
li ul, li ol {
  margin: 0;
  padding: 0;
}

img, video {
  max-width: 100%;
}

:root {
  --black: #292F36;
  --white: #F7FFF7;
  --coral: #fc814a;
  --teal: #4ECDC4;
  --green: #c2e812;
  --yellow: #FFE66D;
  --accent-bright: rgba(200, 226, 231, 0.9);
  --accent: rgba(200, 226, 231, 0.75);
  --accent-faded: rgba(121, 202, 216, 0.3);
  --modal-bg: rgba(34, 41, 41, 0.69);
  --page-margin-x: 1.2rem;
  --page-margin-y: 1.2rem;
  --gap-x: 1rem;
  --gap-y: 1rem;
}
@media only screen and (min-width: 360px) {
  :root {
    --page-margin-x: 2rem;
    --page-margin-y: 1.5rem;
  }
}
@media only screen and (min-width: 540px) {
  :root {
    --page-margin-x: 3.2rem;
    --page-margin-y: 2.4rem;
    --gap-x: 2rem;
  }
}

:root {
  line-height: 1.35;
}

h1 {
  font-weight: 400;
  font-size: 1.8rem;
}
@media only screen and (min-width: 540px) {
  h1 {
    font-size: 2.4rem;
  }
}

h2 {
  font-weight: 400;
  font-size: 1.5rem;
}
@media only screen and (min-width: 540px) {
  h2 {
    font-size: 1.8rem;
  }
}

body {
  background-color: var(--black);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: var(--doc-height);
  display: grid;
  place-items: center;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  overflow: hidden;
}

#root {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  color: var(--white);
  font-family: "DM Sans", sans-serif;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  justify-items: stretch;
  outline: 1px solid var(--accent-faded);
  overflow: hidden;
  box-shadow: 0rem 6rem 10rem 10rem rgba(0, 0, 0, 0.3725490196);
}
@media only screen and (min-width: 720px) {
  #root {
    max-height: 900px;
  }
}
#root p {
  font-weight: 300;
  font-size: 1rem;
}
#root a {
  text-decoration: none;
  font-weight: 300;
}
#root a:hover {
  text-decoration: underline;
}
#root svg {
  fill: var(--white);
}

header, footer {
  padding: var(--page-margin-y) var(--page-margin-x);
}

main {
  padding: 0 var(--page-margin-x);
  display: grid;
  grid-auto-rows: min-content;
  gap: var(--gap-y) var(--gap-x);
  overflow-x: hidden;
  overflow-y: auto;
}
main .breadcrumb {
  display: none;
  color: var(--accent);
}
@media only screen and (min-width: 540px) {
  main .breadcrumb {
    display: block;
  }
}

#portfolio-page {
  display: grid;
  grid-template-areas: "heading" "card" "nav";
  grid-template-rows: min-content 1fr min-content;
}
#portfolio-page h1::after {
  content: "";
  height: 1px;
  display: block;
  margin-top: 0.4em;
  background-color: var(--accent-faded);
}
@media only screen and (min-width: 540px) {
  #portfolio-page h1::after {
    display: none;
  }
}
#portfolio-page article {
  grid-area: card;
}
#portfolio-page h1 {
  grid-area: heading;
}
#portfolio-page nav {
  grid-area: nav;
}
#portfolio-page .breadcrumb {
  grid-area: breadcrumb;
}
#portfolio-page nav ul {
  display: none;
}
#portfolio-page nav .buttons {
  display: flex;
  gap: 1.2em;
}
#portfolio-page nav .buttons a {
  border: 1px solid var(--accent-faded);
  padding: 0.8em 1.4em;
  flex-grow: 1;
  text-align: left;
}
#portfolio-page nav .buttons a:hover {
  border-color: var(--white);
  border-radius: 0;
  transition: border-color 0.12s;
}
#portfolio-page article {
  overflow-y: auto;
}
@media only screen and (min-width: 540px) {
  #portfolio-page {
    grid-template-areas: "breadcrumb" "heading" "card" "nav";
    grid-template-rows: repeat(2, min-content) 1fr min-content;
  }
  #portfolio-page article {
    display: grid;
    border: 1px solid var(--accent-faded);
    padding: var(--gap-y) var(--gap-x);
    transition: border-color 0.2s;
  }
  #portfolio-page article p {
    color: var(--accent);
    transition: color 0.2s;
  }
  #portfolio-page article p:not(.subtitle) {
    margin-top: 0.6em;
  }
  #portfolio-page article p em, #portfolio-page article p strong {
    color: var(--accent-bright);
    transition: color 0.2s;
  }
  #portfolio-page article p em {
    color: var(--white);
  }
  #portfolio-page article:hover {
    border-color: var(--accent);
  }
  #portfolio-page article:hover p:not(.info) {
    color: currentColor;
  }
  #portfolio-page article:hover strong {
    color: white;
  }
}
@media only screen and (min-width: 720px) {
  #portfolio-page {
    grid-template-columns: 5fr 2fr;
    grid-template-rows: min-content min-content 1fr;
    grid-template-areas: "breadcrumb breadcrumb" "heading heading" "card nav";
  }
  #portfolio-page nav {
    display: flex;
    gap: 0.6em;
    flex-direction: column;
  }
  #portfolio-page nav ul {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 0.6em;
  }
  #portfolio-page nav ul a {
    color: var(--accent);
  }
  #portfolio-page nav ul a.active {
    color: var(--white);
  }
}

#portfolio-page article {
  position: relative;
  display: grid;
  gap: var(--gap-y) var(--gap-x);
  grid-template-rows: repeat(3, min-content) 1fr;
  grid-template-areas: "title" "location" "content" "services";
}
#portfolio-page article .location {
  grid-area: location;
}
#portfolio-page article h2 {
  grid-area: title;
}
#portfolio-page article .content {
  grid-area: content;
  overflow-y: auto;
}
#portfolio-page article .services {
  grid-area: services;
}
#portfolio-page article .date {
  display: none;
}
#portfolio-page article p.info {
  color: var(--accent);
}
#portfolio-page article .services {
  display: flex;
  gap: 0.5em;
}
#portfolio-page article .services h3 {
  font-size: 1em;
  font-weight: 300;
  color: var(--accent);
}
#portfolio-page article .services ul {
  display: flex;
  gap: 0.4em 0.6em;
  flex-wrap: wrap;
}
#portfolio-page article .services ul li {
  border: 1px solid var(--accent-faded);
  padding: 0.4em 1em;
}
#portfolio-page article .date {
  white-space: nowrap;
}
@media only screen and (min-width: 720px) {
  #portfolio-page article {
    grid-template-rows: 30px min-content 1fr min-content;
    grid-template-columns: 1fr min-content;
    grid-template-areas: "location date" "title title" "content content" "services services";
  }
}

#contact-page {
  --section-gap-x: 1em;
  --section-gap-y: 0.6em;
}
#contact-page section {
  display: flex;
  flex-direction: column;
  gap: var(--section-gap-y);
}
#contact-page section h1 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
@media only screen and (min-width: 720px) {
  #contact-page section h1 {
    font-size: 1.8rem;
  }
}
#contact-page section ul {
  display: flex;
  flex-direction: column;
  gap: var(--section-gap-y);
}
#contact-page section li {
  display: flex;
  gap: var(--section-gap-x);
  align-items: center;
}

#services-page {
  display: grid;
  grid-template-areas: "heading" "card" "nav";
  grid-template-rows: min-content 1fr min-content;
}
#services-page article {
  grid-area: card;
}
#services-page h1 {
  grid-area: heading;
}
#services-page nav {
  grid-area: nav;
}
#services-page .breadcrumb {
  grid-area: breadcrumb;
}
#services-page nav ul {
  display: none;
}
#services-page nav .buttons {
  display: flex;
  gap: 1.2em;
}
#services-page nav .buttons a {
  border: 1px solid var(--accent-faded);
  padding: 0.8em 1.4em;
  flex-grow: 1;
  text-align: left;
}
#services-page nav .buttons a:hover {
  border-color: var(--white);
  border-radius: 0;
  transition: border-color 0.12s;
}
#services-page article {
  overflow-y: auto;
}
@media only screen and (min-width: 540px) {
  #services-page {
    grid-template-areas: "breadcrumb" "heading" "card" "nav";
    grid-template-rows: repeat(2, min-content) 1fr min-content;
  }
  #services-page article {
    display: grid;
    border: 1px solid var(--accent-faded);
    padding: var(--gap-y) var(--gap-x);
    transition: border-color 0.2s;
  }
  #services-page article p {
    color: var(--accent);
    transition: color 0.2s;
  }
  #services-page article p:not(.subtitle) {
    margin-top: 0.6em;
  }
  #services-page article p em, #services-page article p strong {
    color: var(--accent-bright);
    transition: color 0.2s;
  }
  #services-page article p em {
    color: var(--white);
  }
  #services-page article:hover {
    border-color: var(--accent);
  }
  #services-page article:hover p:not(.info) {
    color: currentColor;
  }
  #services-page article:hover strong {
    color: white;
  }
}
@media only screen and (min-width: 720px) {
  #services-page {
    grid-template-columns: 5fr 2fr;
    grid-template-rows: min-content min-content 1fr;
    grid-template-areas: "breadcrumb breadcrumb" "heading heading" "card nav";
  }
  #services-page nav {
    display: flex;
    gap: 0.6em;
    flex-direction: column;
  }
  #services-page nav ul {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 0.6em;
  }
  #services-page nav ul a {
    color: var(--accent);
  }
  #services-page nav ul a.active {
    color: var(--white);
  }
}

#services-page article {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap-y);
  grid-auto-rows: min-content;
}

#services-page section::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: var(--accent-faded);
}

header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: var(--gap-x);
  z-index: 10;
}
header svg {
  width: 48px;
  fill: var(--white);
}
header nav {
  display: none;
  height: 100%;
  flex-grow: 1;
  justify-content: end;
}
header nav ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 2rem;
  height: 100%;
  grid-template-rows: repeat(2, 32px);
  align-items: end;
}
header nav ul li {
  font-size: 0.9rem;
  line-height: 1em;
}
header nav ul a {
  text-decoration: none;
}
header nav ul a:hover {
  text-decoration: underline;
}
header h2 {
  font-size: 1.2em;
  line-height: 1em;
  font-weight: 300;
  white-space: nowrap;
  display: none;
}
@media only screen and (min-width: 540px) {
  header nav {
    display: flex;
  }
  header nav ul {
    display: flex;
  }
  header .material-symbols-outlined {
    display: none;
  }
}
@media only screen and (min-width: 720px) {
  header svg {
    width: 60px;
  }
  header h2 {
    display: block;
  }
}

footer {
  display: flex;
  gap: var(--page-margin-x);
  align-items: center;
  justify-content: stretch;
}

button {
  background: none;
  padding: var(--gap-y) var(--gap-x);
  border: 1px solid var(--white);
  transition: border-radius 0.2s;
  cursor: pointer;
  flex-grow: 1;
}
@media only screen and (min-width: 540px) {
  button {
    flex-grow: 0;
    padding: var(--gap-y) var(--page-margin-x);
  }
}
button:hover {
  border-radius: 1rem;
}
button:active {
  border-radius: 0;
}

header button {
  flex-grow: 0;
  padding: 0;
  height: 40px;
  width: 40px;
  border: 1px solid var(--accent-faded);
}
header button:hover {
  border-color: var(--accent);
  border-radius: 0;
}

.vsep {
  background-color: currentColor;
  min-height: 1px;
  margin: 0 var(--page-margin-x);
}

.card-display {
  display: flex;
  gap: var(--gap-x);
  scrollbar-width: none;
}

.card {
  grid-auto-rows: min-content;
  cursor: grab;
  min-width: calc(100vw - 2 * var(--page-margin-x));
  display: grid;
  border: 1px solid var(--accent-faded);
  padding: var(--gap-y) var(--gap-x);
  transition: border-color 0.2s;
}
.card:active, .card.dragging {
  cursor: grabbing;
}
.card p {
  color: var(--accent);
  transition: color 0.2s;
}
.card p:not(.subtitle) {
  margin-top: 0.6em;
}
.card p em, .card p strong {
  color: var(--accent-bright);
  transition: color 0.2s;
}
.card p em {
  color: var(--white);
}
.card:hover {
  border-color: var(--accent);
}
.card:hover p:not(.info) {
  color: currentColor;
}
.card:hover strong {
  color: white;
}
@media only screen and (min-width: 540px) {
  .card {
    min-width: 320px;
    max-width: 400px;
  }
}
.card:hover p:not(.info) {
  color: var(--white);
}
.card:hover h3 {
  text-decoration: underline;
}

section {
  display: flex;
  flex-direction: column;
  gap: var(--gap-y);
  overflow: hidden;
}
section:not(:first-of-type)::before {
  content: "";
  width: 100%;
  height: 1px;
  background-color: var(--accent-faded);
}
section.services {
  height: min-content;
}

.modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: var(--doc-height);
  z-index: -5;
  background-color: var(--modal-bg);
  transition: height 0.25s, transform 0.25s;
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  padding: 0 var(--page-margin-x);
  gap: var(--page-margin-y);
}
.modal.hidden {
  height: 0;
}
.modal a {
  font-size: 1.4rem;
  transition: opacity 0.1s;
}
.modal.hidden a {
  opacity: 0;
  pointer-events: none;
}

.carousel {
  display: flex;
  overflow-x: hidden;
  gap: var(--gap-x);
  scrollbar-width: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -webkit-tap-highlight-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/sass/globals/_reset.scss","webpack://./src/sass/style.scss","webpack://./src/sass/globals/_theme.scss","webpack://./src/sass/globals/_mixins.scss","webpack://./src/sass/globals/_typography.scss","webpack://./src/sass/layout/_root.scss","webpack://./src/sass/layout/_portfolio.scss","webpack://./src/sass/layout/_contact.scss","webpack://./src/sass/layout/_services.scss","webpack://./src/sass/components/_header.scss","webpack://./src/sass/components/_footer.scss","webpack://./src/sass/components/_button.scss","webpack://./src/sass/components/_vsep.scss","webpack://./src/sass/components/_card.scss","webpack://./src/sass/components/_section.scss","webpack://./src/sass/components/_modal.scss","webpack://./src/sass/components/_carousel.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;ACAJ;;ADGA;EACI,SAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;ACAJ;ADCI;EACI,mBAAA;ACCR;;ADKA;EACI,yBAAA;EACA,iBAAA;ACFJ;;ADKA;EACI,gBAAA;ACFJ;ADGI;EACI,SAAA;EACA,UAAA;ACDR;;ADKA;EACI,eAAA;ACFJ;;AC5BA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAEA,yCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kCAAA;EAGA,uBAAA;EACA,uBAAA;EAEA,aAAA;EACA,aAAA;AD2BF;AEpCQ;EDTR;IAqBI,qBAAA;IACA,uBAAA;ED4BF;AACF;AE1CQ;EDTR;IA0BI,uBAAA;IACA,uBAAA;IACA,aAAA;ED6BF;AACF;;AGxDA;EACE,iBAAA;AH2DF;;AGxDA;EACI,gBAAA;EACA,iBAAA;AH2DJ;AE1DQ;ECHR;IAIM,iBAAA;EH6DJ;AACF;;AG1DA;EACI,gBAAA;EACA,iBAAA;AH6DJ;AEpEQ;ECKR;IAIQ,iBAAA;EH+DN;AACF;;AInFA;EACE,8BAAA;EACA,yDAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,gBAAA;AJsFF;;AInFA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,aAAA;EACA,+CAAA;EACA,sBAAA;EACA,sCAAA;EACA,gBAAA;EAGA,6DAAA;AJoFF;AElGQ;EECR;IAgBI,iBAAA;EJqFF;AACF;AInFE;EACE,gBAAA;EACA,eAAA;AJqFJ;AIlFE;EACE,qBAAA;EACA,gBAAA;AJoFJ;AInFI;EACE,0BAAA;AJqFN;AIjFE;EACE,kBAAA;AJmFJ;;AI/EA;EACE,kDAAA;AJkFF;;AI/EA;EAGE,+BAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AJgFF;AI9EE;EACE,aAAA;EACA,oBAAA;AJgFJ;AEtIQ;EEoDN;IAII,cAAA;EJkFJ;AACF;;AKrJA;EH+DI,aAAA;EACA,2CACI;EAGJ,+CACI;AFsFR;AK1JI;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,qCAAA;AL4JR;AExJQ;EGTJ;IAOQ,aAAA;EL8JV;AACF;AE9FI;EAAU,eAAA;AFiGd;AEhGI;EAAK,kBAAA;AFmGT;AElGI;EAAM,cAAA;AFqGV;AEpGI;EAAc,qBAAA;AFuGlB;AErGI;EACI,aAAA;AFuGR;AErGI;EACI,aAAA;EACA,UAAA;AFuGR;AEtGQ;EACI,qCAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AFwGZ;AEvGY;EACI,0BAAA;EACA,gBAAA;EACA,8BAAA;AFyGhB;AEpGI;EACI,gBAAA;AFsGR;AE9LQ;EGVR;IHsGQ,wDACI;IAIJ,0DACI;EFiGV;EE9FM;IAnFJ,aAAA;IAGA,qCAAA;IACA,kCAAA;IACA,6BAAA;EFkLF;EEhLE;IACI,oBAAA;IACA,sBAAA;EFkLN;EEjLM;IACE,iBAAA;EFmLR;EEjLM;IACI,2BAAA;IACA,sBAAA;EFmLV;EEjLM;IACI,mBAAA;EFmLV;EE/KE;IACI,2BAAA;EFiLN;EEhLM;IACI,mBAAA;EFkLV;EEhLM;IACI,YAAA;EFkLV;AACF;AEjOQ;EGVR;IHsHQ,8BAAA;IACA,+CACI;IAGJ,yEACI;EFqHV;EEjHM;IACI,aAAA;IACA,UAAA;IACA,sBAAA;EFmHV;EEjHM;IACI,YAAA;IACA,aAAA;IACA,sBAAA;IACA,UAAA;EFmHV;EElHU;IACI,oBAAA;EFoHd;EEnHc;IACI,mBAAA;EFqHlB;AACF;;AKrPA;EAEI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,8CACI;EAEJ,4DACI;ALoPR;AK9OI;EAAY,mBAAA;ALiPhB;AKhPI;EAAK,gBAAA;ALmPT;AKlPI;EAAW,kBAAA;EAAoB,gBAAA;ALsPnC;AKrPI;EAAY,mBAAA;ALwPhB;AKvPI;EAAQ,aAAA;AL0PZ;AKxPI;EACI,oBAAA;AL0PR;AKrPI;EAMI,aAAA;EACA,UAAA;ALkPR;AKxPQ;EACI,cAAA;EACA,gBAAA;EACA,oBAAA;AL0PZ;AKtPQ;EACI,aAAA;EACA,gBAAA;EACA,eAAA;ALwPZ;AKvPY;EACI,qCAAA;EACA,kBAAA;ALyPhB;AKrPI;EACI,mBAAA;ALuPR;AEzSQ;EGIR;IAkDQ,oDACI;IAIJ,sCACI;IACJ,wFACI;ELiPV;AACF;;AM1TA;EACE,oBAAA;EACA,sBAAA;AN6TF;AMxTE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AN0TJ;AMvTI;EACE,iBAAA;EAKA,mBAAA;ANqTN;AE9TQ;EIGJ;IAII,iBAAA;EN2TN;AACF;AMvTI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;ANyTN;AMtTI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;ANwTN;;AOvVA;EL+DI,aAAA;EACA,2CACI;EAGJ,+CACI;AFwRR;AEpRI;EAAU,eAAA;AFuRd;AEtRI;EAAK,kBAAA;AFyRT;AExRI;EAAM,cAAA;AF2RV;AE1RI;EAAc,qBAAA;AF6RlB;AE3RI;EACI,aAAA;AF6RR;AE3RI;EACI,aAAA;EACA,UAAA;AF6RR;AE5RQ;EACI,qCAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AF8RZ;AE7RY;EACI,0BAAA;EACA,gBAAA;EACA,8BAAA;AF+RhB;AE1RI;EACI,gBAAA;AF4RR;AEpXQ;EKVR;ILsGQ,wDACI;IAIJ,0DACI;EFuRV;EEpRM;IAnFJ,aAAA;IAGA,qCAAA;IACA,kCAAA;IACA,6BAAA;EFwWF;EEtWE;IACI,oBAAA;IACA,sBAAA;EFwWN;EEvWM;IACE,iBAAA;EFyWR;EEvWM;IACI,2BAAA;IACA,sBAAA;EFyWV;EEvWM;IACI,mBAAA;EFyWV;EErWE;IACI,2BAAA;EFuWN;EEtWM;IACI,mBAAA;EFwWV;EEtWM;IACI,YAAA;EFwWV;AACF;AEvZQ;EKVR;ILsHQ,8BAAA;IACA,+CACI;IAGJ,yEACI;EF2SV;EEvSM;IACI,aAAA;IACA,UAAA;IACA,sBAAA;EFySV;EEvSM;IACI,YAAA;IACA,aAAA;IACA,sBAAA;IACA,UAAA;EFySV;EExSU;IACI,oBAAA;EF0Sd;EEzSc;IACI,mBAAA;EF2SlB;AACF;;AOrbA;EACI,aAAA;EACA,0BAAA;EACA,iBAAA;EAEA,2BAAA;APubJ;;AOnbI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;APsbR;;AQvcA;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;AR0cF;AQxcE;EACE,WAAA;EAEA,kBAAA;ARycJ;AQtcE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;ARwcJ;AQrcE;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;ARucJ;AQrcI;EACE,iBAAA;EACA,gBAAA;ARucN;AQrcI;EACE,qBAAA;ARucN;AQtcM;EACE,0BAAA;ARwcR;AQncE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;ARqcJ;AExeQ;EMuCJ;IACE,aAAA;ERocJ;EQlcE;IACE,aAAA;ERocJ;EQlcE;IACE,aAAA;ERocJ;AACF;AEnfQ;EMmDJ;IACE,WAAA;ERmcJ;EQjcE;IACE,cAAA;ERmcJ;AACF;;ASvgBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;AT0gBF;;AU5gBA;EACE,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;AV+gBF;AE3gBQ;EQVR;IASI,YAAA;IACA,0CAAA;EVghBF;AACF;AU/gBE;EACE,mBAAA;AVihBJ;AU/gBE;EACE,gBAAA;AVihBJ;;AU7gBA;EACE,YAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;AVghBF;AU9gBE;EACE,2BAAA;EACA,gBAAA;AVghBJ;;AW/iBA;EACE,8BAAA;EACA,eAAA;EACA,8BAAA;AXkjBF;;AYnjBA;EACE,aAAA;EACA,iBAAA;EVsBE,qBAAA;AFiiBJ;;AYjjBA;EAEE,2BAAA;EACA,YAAA;EACA,iDAAA;EVgBE,aAAA;EAGA,qCAAA;EACA,kCAAA;EACA,6BAAA;AFkiBJ;AYrjBE;EAEE,gBAAA;AZsjBJ;AEniBI;EACI,oBAAA;EACA,sBAAA;AFqiBR;AEpiBQ;EACE,iBAAA;AFsiBV;AEpiBQ;EACI,2BAAA;EACA,sBAAA;AFsiBZ;AEpiBQ;EACI,mBAAA;AFsiBZ;AEliBI;EACI,2BAAA;AFoiBR;AEniBQ;EACI,mBAAA;AFqiBZ;AEniBQ;EACI,YAAA;AFqiBZ;AEnlBQ;EUFR;IAaI,gBAAA;IACA,gBAAA;EZ4kBF;AACF;AYzkBI;EACE,mBAAA;AZ2kBN;AYzkBI;EACE,0BAAA;AZ2kBN;;Aa3mBA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;Ab8mBJ;Aa5mBI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;Ab8mBR;Aa5mBI;EACI,mBAAA;Ab8mBR;;Ac3nBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,iCAAA;EACA,yCAAA;EACA,0BAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;Ad6nBF;Ac5nBE;EACE,SAAA;Ad8nBJ;Ac1nBE;EACE,iBAAA;EACA,wBAAA;Ad4nBJ;AcznBE;EACE,UAAA;EACA,oBAAA;Ad2nBJ;;AetpBA;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;EbqBA,qBAAA;EAPA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wCAAA;AF6oBJ","sourcesContent":["// global behavior\n\nhtml {\n    box-sizing: border-box;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    font-family: inherit;\n    color: inherit;\n    box-sizing: inherit;\n    &::before, &::after {\n        box-sizing: inherit;\n    }\n}\n\n// specific element styles\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\nli {\n    list-style: none;\n    ul, ol {\n        margin: 0;\n        padding: 0;\n    }\n}\n\nimg, video {\n    max-width: 100%;\n}","@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap\");\nhtml {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  font-family: inherit;\n  color: inherit;\n  box-sizing: inherit;\n}\n*::before, *::after {\n  box-sizing: inherit;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nli {\n  list-style: none;\n}\nli ul, li ol {\n  margin: 0;\n  padding: 0;\n}\n\nimg, video {\n  max-width: 100%;\n}\n\n:root {\n  --black: #292F36;\n  --white: #F7FFF7;\n  --coral: #fc814a;\n  --teal: #4ECDC4;\n  --green: #c2e812;\n  --yellow: #FFE66D;\n  --accent-bright: rgba(200, 226, 231, 0.9);\n  --accent: rgba(200, 226, 231, 0.75);\n  --accent-faded: rgba(121, 202, 216, 0.3);\n  --modal-bg: rgba(34, 41, 41, 0.69);\n  --page-margin-x: 1.2rem;\n  --page-margin-y: 1.2rem;\n  --gap-x: 1rem;\n  --gap-y: 1rem;\n}\n@media only screen and (min-width: 360px) {\n  :root {\n    --page-margin-x: 2rem;\n    --page-margin-y: 1.5rem;\n  }\n}\n@media only screen and (min-width: 540px) {\n  :root {\n    --page-margin-x: 3.2rem;\n    --page-margin-y: 2.4rem;\n    --gap-x: 2rem;\n  }\n}\n\n:root {\n  line-height: 1.35;\n}\n\nh1 {\n  font-weight: 400;\n  font-size: 1.8rem;\n}\n@media only screen and (min-width: 540px) {\n  h1 {\n    font-size: 2.4rem;\n  }\n}\n\nh2 {\n  font-weight: 400;\n  font-size: 1.5rem;\n}\n@media only screen and (min-width: 540px) {\n  h2 {\n    font-size: 1.8rem;\n  }\n}\n\nbody {\n  background-color: var(--black);\n  background-image: url(\"../assets/MARBLE-01-Black.jpg\");\n  height: var(--doc-height);\n  display: grid;\n  place-items: center;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  overflow: hidden;\n}\n\n#root {\n  width: 100%;\n  max-width: 1200px;\n  height: 100%;\n  color: var(--white);\n  font-family: \"DM Sans\", sans-serif;\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  justify-items: stretch;\n  outline: 1px solid var(--accent-faded);\n  overflow: hidden;\n  box-shadow: 0rem 6rem 10rem 10rem rgba(0, 0, 0, 0.3725490196);\n}\n@media only screen and (min-width: 720px) {\n  #root {\n    max-height: 900px;\n  }\n}\n#root p {\n  font-weight: 300;\n  font-size: 1rem;\n}\n#root a {\n  text-decoration: none;\n  font-weight: 300;\n}\n#root a:hover {\n  text-decoration: underline;\n}\n#root svg {\n  fill: var(--white);\n}\n\nheader, footer {\n  padding: var(--page-margin-y) var(--page-margin-x);\n}\n\nmain {\n  padding: 0 var(--page-margin-x);\n  display: grid;\n  grid-auto-rows: min-content;\n  gap: var(--gap-y) var(--gap-x);\n  overflow-x: hidden;\n  overflow-y: auto;\n}\nmain .breadcrumb {\n  display: none;\n  color: var(--accent);\n}\n@media only screen and (min-width: 540px) {\n  main .breadcrumb {\n    display: block;\n  }\n}\n\n#portfolio-page {\n  display: grid;\n  grid-template-areas: \"heading\" \"card\" \"nav\";\n  grid-template-rows: min-content 1fr min-content;\n}\n#portfolio-page h1::after {\n  content: \"\";\n  height: 1px;\n  display: block;\n  margin-top: 0.4em;\n  background-color: var(--accent-faded);\n}\n@media only screen and (min-width: 540px) {\n  #portfolio-page h1::after {\n    display: none;\n  }\n}\n#portfolio-page article {\n  grid-area: card;\n}\n#portfolio-page h1 {\n  grid-area: heading;\n}\n#portfolio-page nav {\n  grid-area: nav;\n}\n#portfolio-page .breadcrumb {\n  grid-area: breadcrumb;\n}\n#portfolio-page nav ul {\n  display: none;\n}\n#portfolio-page nav .buttons {\n  display: flex;\n  gap: 1.2em;\n}\n#portfolio-page nav .buttons a {\n  border: 1px solid var(--accent-faded);\n  padding: 0.8em 1.4em;\n  flex-grow: 1;\n  text-align: left;\n}\n#portfolio-page nav .buttons a:hover {\n  border-color: var(--white);\n  border-radius: 0;\n  transition: border-color 0.12s;\n}\n#portfolio-page article {\n  overflow-y: auto;\n}\n@media only screen and (min-width: 540px) {\n  #portfolio-page {\n    grid-template-areas: \"breadcrumb\" \"heading\" \"card\" \"nav\";\n    grid-template-rows: repeat(2, min-content) 1fr min-content;\n  }\n  #portfolio-page article {\n    display: grid;\n    border: 1px solid var(--accent-faded);\n    padding: var(--gap-y) var(--gap-x);\n    transition: border-color 0.2s;\n  }\n  #portfolio-page article p {\n    color: var(--accent);\n    transition: color 0.2s;\n  }\n  #portfolio-page article p:not(.subtitle) {\n    margin-top: 0.6em;\n  }\n  #portfolio-page article p em, #portfolio-page article p strong {\n    color: var(--accent-bright);\n    transition: color 0.2s;\n  }\n  #portfolio-page article p em {\n    color: var(--white);\n  }\n  #portfolio-page article:hover {\n    border-color: var(--accent);\n  }\n  #portfolio-page article:hover p:not(.info) {\n    color: currentColor;\n  }\n  #portfolio-page article:hover strong {\n    color: white;\n  }\n}\n@media only screen and (min-width: 720px) {\n  #portfolio-page {\n    grid-template-columns: 5fr 2fr;\n    grid-template-rows: min-content min-content 1fr;\n    grid-template-areas: \"breadcrumb breadcrumb\" \"heading heading\" \"card nav\";\n  }\n  #portfolio-page nav {\n    display: flex;\n    gap: 0.6em;\n    flex-direction: column;\n  }\n  #portfolio-page nav ul {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6em;\n  }\n  #portfolio-page nav ul a {\n    color: var(--accent);\n  }\n  #portfolio-page nav ul a.active {\n    color: var(--white);\n  }\n}\n\n#portfolio-page article {\n  position: relative;\n  display: grid;\n  gap: var(--gap-y) var(--gap-x);\n  grid-template-rows: repeat(3, min-content) 1fr;\n  grid-template-areas: \"title\" \"location\" \"content\" \"services\";\n}\n#portfolio-page article .location {\n  grid-area: location;\n}\n#portfolio-page article h2 {\n  grid-area: title;\n}\n#portfolio-page article .content {\n  grid-area: content;\n  overflow-y: auto;\n}\n#portfolio-page article .services {\n  grid-area: services;\n}\n#portfolio-page article .date {\n  display: none;\n}\n#portfolio-page article p.info {\n  color: var(--accent);\n}\n#portfolio-page article .services {\n  display: flex;\n  gap: 0.5em;\n}\n#portfolio-page article .services h3 {\n  font-size: 1em;\n  font-weight: 300;\n  color: var(--accent);\n}\n#portfolio-page article .services ul {\n  display: flex;\n  gap: 0.4em 0.6em;\n  flex-wrap: wrap;\n}\n#portfolio-page article .services ul li {\n  border: 1px solid var(--accent-faded);\n  padding: 0.4em 1em;\n}\n#portfolio-page article .date {\n  white-space: nowrap;\n}\n@media only screen and (min-width: 720px) {\n  #portfolio-page article {\n    grid-template-rows: 30px min-content 1fr min-content;\n    grid-template-columns: 1fr min-content;\n    grid-template-areas: \"location date\" \"title title\" \"content content\" \"services services\";\n  }\n}\n\n#contact-page {\n  --section-gap-x: 1em;\n  --section-gap-y: 0.6em;\n}\n#contact-page section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--section-gap-y);\n}\n#contact-page section h1 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n@media only screen and (min-width: 720px) {\n  #contact-page section h1 {\n    font-size: 1.8rem;\n  }\n}\n#contact-page section ul {\n  display: flex;\n  flex-direction: column;\n  gap: var(--section-gap-y);\n}\n#contact-page section li {\n  display: flex;\n  gap: var(--section-gap-x);\n  align-items: center;\n}\n\n#services-page {\n  display: grid;\n  grid-template-areas: \"heading\" \"card\" \"nav\";\n  grid-template-rows: min-content 1fr min-content;\n}\n#services-page article {\n  grid-area: card;\n}\n#services-page h1 {\n  grid-area: heading;\n}\n#services-page nav {\n  grid-area: nav;\n}\n#services-page .breadcrumb {\n  grid-area: breadcrumb;\n}\n#services-page nav ul {\n  display: none;\n}\n#services-page nav .buttons {\n  display: flex;\n  gap: 1.2em;\n}\n#services-page nav .buttons a {\n  border: 1px solid var(--accent-faded);\n  padding: 0.8em 1.4em;\n  flex-grow: 1;\n  text-align: left;\n}\n#services-page nav .buttons a:hover {\n  border-color: var(--white);\n  border-radius: 0;\n  transition: border-color 0.12s;\n}\n#services-page article {\n  overflow-y: auto;\n}\n@media only screen and (min-width: 540px) {\n  #services-page {\n    grid-template-areas: \"breadcrumb\" \"heading\" \"card\" \"nav\";\n    grid-template-rows: repeat(2, min-content) 1fr min-content;\n  }\n  #services-page article {\n    display: grid;\n    border: 1px solid var(--accent-faded);\n    padding: var(--gap-y) var(--gap-x);\n    transition: border-color 0.2s;\n  }\n  #services-page article p {\n    color: var(--accent);\n    transition: color 0.2s;\n  }\n  #services-page article p:not(.subtitle) {\n    margin-top: 0.6em;\n  }\n  #services-page article p em, #services-page article p strong {\n    color: var(--accent-bright);\n    transition: color 0.2s;\n  }\n  #services-page article p em {\n    color: var(--white);\n  }\n  #services-page article:hover {\n    border-color: var(--accent);\n  }\n  #services-page article:hover p:not(.info) {\n    color: currentColor;\n  }\n  #services-page article:hover strong {\n    color: white;\n  }\n}\n@media only screen and (min-width: 720px) {\n  #services-page {\n    grid-template-columns: 5fr 2fr;\n    grid-template-rows: min-content min-content 1fr;\n    grid-template-areas: \"breadcrumb breadcrumb\" \"heading heading\" \"card nav\";\n  }\n  #services-page nav {\n    display: flex;\n    gap: 0.6em;\n    flex-direction: column;\n  }\n  #services-page nav ul {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6em;\n  }\n  #services-page nav ul a {\n    color: var(--accent);\n  }\n  #services-page nav ul a.active {\n    color: var(--white);\n  }\n}\n\n#services-page article {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--gap-y);\n  grid-auto-rows: min-content;\n}\n\n#services-page section::before {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background-color: var(--accent-faded);\n}\n\nheader {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: var(--gap-x);\n  z-index: 10;\n}\nheader svg {\n  width: 48px;\n  fill: var(--white);\n}\nheader nav {\n  display: none;\n  height: 100%;\n  flex-grow: 1;\n  justify-content: end;\n}\nheader nav ul {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0 2rem;\n  height: 100%;\n  grid-template-rows: repeat(2, 32px);\n  align-items: end;\n}\nheader nav ul li {\n  font-size: 0.9rem;\n  line-height: 1em;\n}\nheader nav ul a {\n  text-decoration: none;\n}\nheader nav ul a:hover {\n  text-decoration: underline;\n}\nheader h2 {\n  font-size: 1.2em;\n  line-height: 1em;\n  font-weight: 300;\n  white-space: nowrap;\n  display: none;\n}\n@media only screen and (min-width: 540px) {\n  header nav {\n    display: flex;\n  }\n  header nav ul {\n    display: flex;\n  }\n  header .material-symbols-outlined {\n    display: none;\n  }\n}\n@media only screen and (min-width: 720px) {\n  header svg {\n    width: 60px;\n  }\n  header h2 {\n    display: block;\n  }\n}\n\nfooter {\n  display: flex;\n  gap: var(--page-margin-x);\n  align-items: center;\n  justify-content: stretch;\n}\n\nbutton {\n  background: none;\n  padding: var(--gap-y) var(--gap-x);\n  border: 1px solid var(--white);\n  transition: border-radius 0.2s;\n  cursor: pointer;\n  flex-grow: 1;\n}\n@media only screen and (min-width: 540px) {\n  button {\n    flex-grow: 0;\n    padding: var(--gap-y) var(--page-margin-x);\n  }\n}\nbutton:hover {\n  border-radius: 1rem;\n}\nbutton:active {\n  border-radius: 0;\n}\n\nheader button {\n  flex-grow: 0;\n  padding: 0;\n  height: 40px;\n  width: 40px;\n  border: 1px solid var(--accent-faded);\n}\nheader button:hover {\n  border-color: var(--accent);\n  border-radius: 0;\n}\n\n.vsep {\n  background-color: currentColor;\n  min-height: 1px;\n  margin: 0 var(--page-margin-x);\n}\n\n.card-display {\n  display: flex;\n  gap: var(--gap-x);\n  scrollbar-width: none;\n}\n\n.card {\n  grid-auto-rows: min-content;\n  cursor: grab;\n  min-width: calc(100vw - 2 * var(--page-margin-x));\n  display: grid;\n  border: 1px solid var(--accent-faded);\n  padding: var(--gap-y) var(--gap-x);\n  transition: border-color 0.2s;\n}\n.card:active, .card.dragging {\n  cursor: grabbing;\n}\n.card p {\n  color: var(--accent);\n  transition: color 0.2s;\n}\n.card p:not(.subtitle) {\n  margin-top: 0.6em;\n}\n.card p em, .card p strong {\n  color: var(--accent-bright);\n  transition: color 0.2s;\n}\n.card p em {\n  color: var(--white);\n}\n.card:hover {\n  border-color: var(--accent);\n}\n.card:hover p:not(.info) {\n  color: currentColor;\n}\n.card:hover strong {\n  color: white;\n}\n@media only screen and (min-width: 540px) {\n  .card {\n    min-width: 320px;\n    max-width: 400px;\n  }\n}\n.card:hover p:not(.info) {\n  color: var(--white);\n}\n.card:hover h3 {\n  text-decoration: underline;\n}\n\nsection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gap-y);\n  overflow: hidden;\n}\nsection:not(:first-of-type)::before {\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background-color: var(--accent-faded);\n}\nsection.services {\n  height: min-content;\n}\n\n.modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--doc-height);\n  z-index: -5;\n  background-color: var(--modal-bg);\n  transition: height 0.25s, transform 0.25s;\n  backdrop-filter: blur(4px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: end;\n  padding: 0 var(--page-margin-x);\n  gap: var(--page-margin-y);\n}\n.modal.hidden {\n  height: 0;\n}\n.modal a {\n  font-size: 1.4rem;\n  transition: opacity 0.1s;\n}\n.modal.hidden a {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.carousel {\n  display: flex;\n  overflow-x: hidden;\n  gap: var(--gap-x);\n  scrollbar-width: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}","@use \"../globals/mixins\" as *;\n\n// variables\n:root {\n  --black: #292F36;\n  --white: #F7FFF7;\n  --coral: #fc814a;\n  --teal: #4ECDC4;\n  --green: #c2e812;\n  --yellow: #FFE66D;\n\n  --accent-bright: rgba(200, 226, 231, 0.9);\n  --accent: rgba(200, 226, 231, 0.75);\n  --accent-faded: rgba(121, 202, 216, 0.3);\n  --modal-bg: rgba(34, 41, 41, 0.69);\n\n\n  --page-margin-x: 1.2rem;\n  --page-margin-y: 1.2rem;\n\n  --gap-x: 1rem;\n  --gap-y: 1rem;\n\n  @include break-at(\"mobile-m\") {\n    --page-margin-x: 2rem;\n    --page-margin-y: 1.5rem;\n  }\n\n  @include break-at(\"tablet-s\") {\n    --page-margin-x: 3.2rem;\n    --page-margin-y: 2.4rem;\n    --gap-x: 2rem;\n  }\n}","$breakpoints: (\n    \"mobile-m\": 360px,\n    \"mobile-l\": 420px,\n    \"tablet-s\": 540px,\n    \"laptop-s\": 720px,\n    \"laptop-l\": 1024px,\n    \"desktop-s\": 1200px,\n    \"desktop-m\": 1440px\n);\n\n@mixin break-at($size) {\n    @if map-has-key($breakpoints, $size) {\n        @media only screen and (min-width: map-get($breakpoints, $size)) {\n            @content;\n        }\n    }\n}\n\n@mixin disable-selection {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n@mixin remove-scrollbars {\n    scrollbar-width: none;\n}\n\n@mixin card {\n    display: grid;\n    // cursor: default;\n\n    border: 1px solid var(--accent-faded);\n    padding: var(--gap-y) var(--gap-x);\n    transition: border-color 0.2s;\n    \n    p {\n        color: var(--accent);\n        transition: color 0.2s;\n        &:not(.subtitle) {\n          margin-top: .6em;\n        }\n        em, strong {\n            color: var(--accent-bright);\n            transition: color 0.2s;\n        }\n        em {\n            color: var(--white);\n        }\n    }\n\n    &:hover {\n        border-color: var(--accent);\n        p:not(.info) {\n            color: currentColor;\n        }\n        strong {\n            color: white;\n\n        }\n    }\n}\n\n@mixin split-interface {\n    display: grid;\n    grid-template-areas:\n        \"heading\"\n        \"card\"\n        \"nav\";\n    grid-template-rows:\n        min-content\n        1fr\n        min-content;\n    \n    article { grid-area: card }\n    h1 { grid-area: heading }\n    nav { grid-area: nav }\n    .breadcrumb { grid-area: breadcrumb }\n    \n    nav ul {\n        display: none;\n    }\n    nav .buttons {\n        display: flex;\n        gap: 1.2em;\n        a {\n            border: 1px solid var(--accent-faded);\n            padding: .8em 1.4em;\n            flex-grow: 1;\n            text-align: left;\n            &:hover {\n                border-color: var(--white);\n                border-radius: 0;\n                transition: border-color .12s;\n            }\n        }\n    }\n\n    article {\n        overflow-y: auto;\n    }\n\n    @include break-at(\"tablet-s\") {\n        grid-template-areas:\n            \"breadcrumb\"\n            \"heading\"\n            \"card\"\n            \"nav\";\n        grid-template-rows:\n            repeat(2, min-content)\n            1fr\n            min-content;\n        article {\n            @include card;\n        }\n    }\n\n\n    @include break-at(\"laptop-s\") {\n        grid-template-columns: 5fr 2fr;\n        grid-template-rows: \n            min-content\n            min-content\n            1fr;\n        grid-template-areas: \n            \"breadcrumb breadcrumb\"\n            \"heading heading\"\n            \"card nav\";\n\n        nav {\n            display: flex;\n            gap: .6em;\n            flex-direction: column;\n        }\n        nav ul {\n            flex-grow: 1;\n            display: flex;\n            flex-direction: column;\n            gap: .6em;\n            a {\n                color: var(--accent);\n                &.active {\n                    color: var(--white);\n                }\n            }\n        }\n    }\n\n}","@use \"./mixins\" as *;\n\n// font declarations\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n\n:root {\n  line-height: 1.35;\n}\n\nh1 {\n    font-weight: 400;\n    font-size: 1.8rem;\n    @include break-at(\"tablet-s\") {\n      font-size: 2.4rem;\n    }\n  }\n\nh2 {\n    font-weight: 400;\n    font-size: 1.5rem;\n    @include break-at(\"tablet-s\") {\n        font-size: 1.8rem;\n    }\n}","@use \"../globals/mixins\" as *;\n\nbody {\n  background-color: var(--black);\n  background-image: url(\"../assets/MARBLE-01-Black.jpg\");\n  height: var(--doc-height);\n  display: grid;\n  place-items: center;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  overflow: hidden;\n}\n\n#root {\n  width: 100%;\n  max-width: 1200px;\n  height: 100%;\n  color: var(--white);\n  font-family: \"DM Sans\", sans-serif;\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  justify-items: stretch;\n  outline: 1px solid var(--accent-faded);\n  overflow: hidden;\n  // outline-offset: 2rem;\n  // padding: 5rem 8rem;\n  box-shadow: 0rem 6rem 10rem 10rem #0000005f;\n\n  @include break-at(\"laptop-s\") {\n    max-height: 900px;\n  }\n\n  p {\n    font-weight: 300;\n    font-size: 1rem;\n  }\n\n  a {\n    text-decoration: none;\n    font-weight: 300;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  svg {\n    fill: var(--white);\n  }\n}\n\nheader, footer {\n  padding: var(--page-margin-y) var(--page-margin-x);\n}\n\nmain {\n  // why did I even?\n  // margin: calc(var(--page-margin-y) * -1 + var(--gap-y)) 0;\n  padding: 0 var(--page-margin-x);\n  display: grid;\n  grid-auto-rows: min-content;\n  gap: var(--gap-y) var(--gap-x);\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  .breadcrumb {\n    display: none;\n    color: var(--accent);\n    @include break-at(\"tablet-s\") {\n      display: block;\n    }\n  }\n}","@use \"../globals/mixins\" as *;\n\n#portfolio-page {\n    h1::after {\n        content: \"\";\n        height: 1px;\n        display: block;\n        margin-top: .4em;\n        background-color: var(--accent-faded);\n        @include break-at(\"tablet-s\") {\n            display: none;\n        }\n    }\n    @include split-interface;\n}\n\n#portfolio-page article {\n    // grid layout\n    position: relative;\n    display: grid;\n    gap: var(--gap-y) var(--gap-x);\n    grid-template-rows:\n        repeat(3, min-content)\n        1fr;\n    grid-template-areas: \n        \"title\"\n        \"location\"\n        // \"date\"\n        \"content\"\n        \"services\";\n    \n    .location { grid-area: location }\n    h2 { grid-area: title }\n    .content { grid-area: content; overflow-y: auto }\n    .services { grid-area: services }\n    .date { display: none; }\n\n    p.info {\n        color: var(--accent)\n    }\n\n    // elements\n\n    .services {\n        h3 {\n            font-size: 1em;\n            font-weight: 300;\n            color: var(--accent);\n        }\n        display: flex;\n        gap: .5em;\n        ul {\n            display: flex;\n            gap: .4em .6em;\n            flex-wrap: wrap;\n            li {\n                border: 1px solid var(--accent-faded);\n                padding: .4em 1em;\n            }\n        }\n    }\n    .date {\n        white-space: nowrap;\n    }\n\n    @include break-at(\"laptop-s\") {\n        grid-template-rows: \n            30px \n            min-content\n            1fr\n            min-content;\n        grid-template-columns:\n            1fr min-content;\n        grid-template-areas: \n            \"location date\"\n            \"title title\"\n            \"content content\"\n            \"services services\";\n    }\n}","@use \"../globals/mixins\" as *;\n\n#contact-page {\n  --section-gap-x: 1em;\n  --section-gap-y: 0.6em; \n  // display: grid;\n  // grid-template-columns: 1fr;\n  // gap: var(--page-margin-y);\n\n  section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--section-gap-y);\n\n\n    h1 {\n      font-size: 1.5rem;\n  \n      @include break-at(\"laptop-s\") {\n        font-size: 1.8rem;\n      }\n      margin-bottom: 1rem;\n    }\n\n    ul {\n      display: flex;\n      flex-direction: column;\n      gap: var(--section-gap-y);\n    }\n\n    li {\n      display: flex;\n      gap: var(--section-gap-x);\n      align-items: center;\n    }\n  }\n}","@use \"../globals/mixins\" as *;\n\n#services-page {\n    @include split-interface;\n}\n\n#services-page article {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: var(--gap-y);\n    // grid-template-rows: min-content 1fr;\n    grid-auto-rows: min-content;\n}\n\n#services-page section {\n    &::before {\n        content: \"\";\n        width: 100%;\n        height: 1px;\n        background-color: var(--accent-faded);\n    }\n}","@use \"../globals/mixins\" as *;\n\nheader {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: var(--gap-x);\n  z-index: 10; // to keep it above the modal\n\n  svg {\n    width: 48px;\n    // height: 6rem;\n    fill: var(--white);\n  }\n\n  nav {\n    display: none;\n    height: 100%;\n    flex-grow: 1;\n    justify-content: end;\n  }\n\n  nav ul {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0 2rem;\n    height: 100%;\n    grid-template-rows: repeat(2, 32px);\n    align-items: end;\n    \n    li {\n      font-size: .9rem;\n      line-height: 1em;\n    }\n    a {\n      text-decoration: none;\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  h2 {\n    font-size: 1.2em;\n    line-height: 1em;\n    font-weight: 300;\n    white-space: nowrap;\n    display: none;\n  }\n\n  @include break-at(\"tablet-s\") {\n    nav {\n      display: flex;\n    }\n    nav ul {\n      display: flex;\n    }\n    .material-symbols-outlined {\n      display: none;\n    }\n  }\n\n  @include break-at(\"laptop-s\") {\n    svg {\n      width: 60px;\n    }\n    h2 {\n      display: block;\n    }\n  }\n}","footer {\n  display: flex;\n  gap: var(--page-margin-x);\n  align-items: center;\n  justify-content: stretch;\n}","@use \"../globals/mixins\" as *;\n\nbutton {\n  background: none;\n  padding: var(--gap-y) var(--gap-x);\n  border: 1px solid var(--white);\n  transition: border-radius 0.2s;\n  cursor: pointer;\n  flex-grow: 1;\n\n  @include break-at(\"tablet-s\") {\n    flex-grow: 0;\n    padding: var(--gap-y) var(--page-margin-x);\n  }\n  &:hover {\n    border-radius: 1rem;\n  }\n  &:active {\n    border-radius: 0;\n  }\n}\n\nheader button {\n  flex-grow: 0;\n  padding: 0;\n  height: 40px;\n  width: 40px;\n  border: 1px solid var(--accent-faded);\n  // z-index: 10;\n  &:hover {\n    border-color: var(--accent);\n    border-radius: 0;\n  }\n}",".vsep {\n  background-color: currentColor;\n  min-height: 1px;\n  margin: 0 var(--page-margin-x);\n}","@use \"../globals/mixins\" as *;\n\n.card-display {\n  display: flex;\n  gap: var(--gap-x);\n  // overflow-y: auto;\n  @include remove-scrollbars;\n  // mask-image: linear-gradient(to left, rgba(0,0,0,0) 0%, rgb(0, 0, 0) 10%, rgb(0, 0, 0) 90%, rgba(0,0,0,0) 100%)\n}\n\n.card {\n  // border-radius: var(--gap-y);\n  grid-auto-rows: min-content;\n  cursor: grab;\n  min-width: calc(100vw - 2 * var(--page-margin-x)); // replace with --doc-width\n\n  &:active,\n  &.dragging {\n    cursor: grabbing; \n  }\n\n  @include card;\n  @include break-at(\"tablet-s\") {\n    min-width: 320px;\n    max-width: 400px;\n  }\n\n  &:hover {\n    p:not(.info) {\n      color: var(--white);\n    }\n    h3 {\n      text-decoration: underline;\n    }\n  }\n}","section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--gap-y);\n    overflow: hidden;\n\n    &:not(:first-of-type)::before {\n        content: \"\";\n        width: 100%;\n        height: 1px;\n        background-color: var(--accent-faded);\n    }\n    &.services {\n        height: min-content;\n    }\n}",".modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--doc-height);\n  z-index: -5;\n  background-color: var(--modal-bg);\n  transition: height .25s, transform 0.25s;\n  backdrop-filter: blur(4px);\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: end;\n  padding: 0 var(--page-margin-x);\n  gap: var(--page-margin-y);\n  &.hidden {\n    height: 0;\n    // max-height: 0;\n  }\n\n  a {\n    font-size: 1.4rem;\n    transition: opacity 0.1s;\n    \n  }\n  &.hidden a {\n    opacity: 0;\n    pointer-events: none;\n  }\n}","@use \"../globals/mixins\" as *;\n\n.carousel {\n    display: flex;\n    overflow-x: hidden;\n    gap: var(--gap-x);\n    @include remove-scrollbars;\n    @include disable-selection;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
